import { FC } from 'react';

const ModalClose: FC = () => {
    return (
        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="切换语言" transform="translate(-1144.000000, -432.000000)">
                    <g id="Rectangle" transform="translate(728.000000, 420.000000)">
                        <g id="01icon/close" transform="translate(416.000000, 12.000000)">
                            <rect id="Rectangle" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="24" height="24"></rect>
                            <path
                                d="M18,6 L6,18 M6,6 L18,18"
                                id="Combined-Shape"
                                strokeOpacity="0.920618444"
                                stroke="#000000"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default ModalClose;
